import { safeParse } from '../../../utils/general/general';
import reportApiError from '../reportApiError/reportApiError';

interface RequestContext {
  verb: string;
  path: string;
}

const onLoad = (
  xhr: XMLHttpRequest,
  resolve: (o: unknown) => void,
  reject: (o: unknown) => void,
  { verb, path }: RequestContext,
) => {
  const json = safeParse(xhr.responseText);

  if (xhr.status === 401) {
    localStorage.removeItem('token');
    const msg = { title: 'Session Expired', text: 'Please signin again to continue.' };
    localStorage.setItem('logout-message', JSON.stringify(msg));
    window.dispatchEvent(new StorageEvent('token-change'));
    reject({ ...json, status: xhr.status });
  }

  // Non-2xx covers 401 too, so failed requests (including session expiry) are
  // reported here exactly once — do not duplicate this in the 401 block above.
  if (xhr.status < 200 || xhr.status >= 300) {
    reportApiError({
      service: 'core',
      method: verb,
      path,
      status: xhr.status,
      failureType: 'http_error',
      responseBody: json,
    });
    reject({ ...json, status: xhr.status });
  }

  const token = xhr.getResponseHeader('Authorization');

  resolve(token ? { ...json, token: token.split(' ')[1] } : json);
};

export default onLoad;
